<template>
  <svg class="pictoNetwork"
       xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink"
       width="24"
       height="24"
       viewBox="0 0 24 24">
    <g >
      <circle cx="4"
              cy="4"
              r="4"
              transform="translate(15.5 0.5)"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1" />
      <circle cx="4"
              cy="4"
              r="4"
              transform="translate(0.5 7.5)"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1" />
      <circle cx="4"
              cy="4"
              r="4"
              transform="translate(15.5 15.5)"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1" />
      <line x1="7"
            y1="4"
            transform="translate(8.5 13.5)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1" />
      <line x1="7"
            y2="4"
            transform="translate(8.5 5.5)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1" />
    </g>
  </svg>
</template>

<script>

export default {
  name: 'PictoNetwork'
}
</script>
